<template>
    <div>
        <admin-header>
            <template #header>
                <admin-breadcrumbs :crumbs="crumbs" />
            </template>
            <!--<template #aux>-->
            <!--<button class="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3" type="button">-->
            <!--    Create-->
            <!--    &lt;!&ndash;</button>&ndash;&gt;-->
            <!--</template>-->
        </admin-header>

        <!-- Mobile list (only on smallest breakpoint) -->
        <div class="sm:hidden">
            <ul class="mt-3 border-t border-gray-200 divide-gray-100 divide-y">
                <li v-for="post in posts">
                    <Link preserve-state :href="route('admin.post', { post: post })" class="group flex items-center justify-between px-4 py-4 hover:bg-gray-50 sm:px-6">
                        <span class="flex items-center w-4/5 space-x-3">
                            <span class="text-sm font-medium leading-6 truncate">{{ post.text }}</span>
                        </span>
                        <!-- Heroicon name: solid/chevron-right -->
                        <svg aria-hidden="true" class="flex-shrink-0 ml-4 w-5 h-5 text-gray-400 group-hover:text-gray-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path clip-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" fill-rule="evenodd" />
                        </svg>
                    </Link>
                </li>
            </ul>
        </div>

        <!-- Desktop table (small breakpoint and up) -->
        <div class="hidden sm:block">
            <div class="inline-block align-middle min-w-full border-b border-gray-200">
                <table class="min-w-full">
                    <thead>
                        <tr class="">
                            <th class="px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase">
                                <span class="lg:pl-2">Challenger</span>
                            </th>
                            <th class="px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase">Challenge</th>
                            <th class="px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase">Participants</th>
                            <th class="px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase">Pledged</th>
                            <th class="px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase">Comments</th>
                            <th class="hidden px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase md:table-cell">Expires</th>
                            <th class="hidden px-6 py-3 text-left text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase md:table-cell">Created</th>
                            <th class="pr-6 py-3 text-right text-gray-500 text-xs font-medium tracking-wider bg-gray-50 border-b border-gray-200 uppercase"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-gray-100 divide-y">
                        <tr v-for="post in posts" class="even:bg-gray-100">
                            <td class="px-6 py-3 text-gray-800 text-sm font-medium">
                                <div class="flex items-center space-x-3 lg:pl-2">
                                    <div>
                                        <avatar :user="post.user" class="w-10 h-10" />
                                    </div>
                                    <div class="flex flex-col items-start">
                                        <!--<Link :href="route('admin.users.show', { user: post.user })" class="hover:text-indigo-600 truncate">-->
                                        <!--    {{ post.user.name }}-->
                                        <!--</Link>-->
                                        <span class="text-gray-600 text-xs font-normal truncate">{{ post.user.tag }}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="px-6 py-3 text-gray-800 text-xs">
                                <div class="line-clamp-2">
                                    <Link :href="route('admin.post', { post: post })" class="hover:text-blue-600">
                                        {{ post.text }}
                                    </Link>
                                </div>
                            </td>
                            <td class="px-6 py-3 text-gray-500 text-sm font-medium">
                                <div class="flex items-center space-x-2">
                                    <div class="flex flex-shrink-0 -space-x-4">
                                        <div v-if="i <= 2" v-for="(participant, i) in post.pendingCompetitors" class="w-10 max-w-none h-10 rounded-full overflow-hidden ring-2 ring-white">
                                            <img :alt="participant.username" class="object-cover object-center" :src="participant.verificationPhotoUrl" />
                                        </div>
                                    </div>
                                    <span v-if="post.pendingCompetitors.length > 3" class="flex-shrink-0 text-xs font-medium leading-5">+{{ post.pendingCompetitors.length - 3 }}</span>
                                </div>
                            </td>
                            <td class="px-6 py-3 text-gray-500 text-sm font-medium">
                                <div :class="{ 'has-tooltip cursor-help': post.pledgesCount }">
                                    {{ post.pledgedAmount | abbr }}
                                    <tooltip>${{ post.pledgedAmount | toLocaleString }}</tooltip>
                                </div>
                            </td>
                            <td class="px-6 py-3 text-gray-500 text-sm font-medium">
                                {{ post.commentsCount | abbr }}
                            </td>
                            <td class="px-6 py-3 text-gray-500 text-sm font-medium">
                                <div class="has-tooltip cursor-help">
                                    {{ post.expiry | calendar }}
                                    <tooltip>{{ post.expiry | datetime }}</tooltip>
                                </div>
                            </td>
                            <td class="hidden px-6 py-3 text-left text-gray-500 whitespace-nowrap text-sm md:table-cell">
                                <div class="has-tooltip cursor-help">
                                    {{ post.createdAt | calendar }}
                                    <tooltip>{{ post.createdAt | datetime }}</tooltip>
                                </div>
                            </td>
                            <td class="pr-6">
                                <div class="relative flex items-center justify-end">
                                    <button
                                        @focus="toggleDropdown(post.id)"
                                        id="challenge-options-menu-0"
                                        aria-haspopup="true"
                                        class="inline-flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-500 bg-transparent rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
                                        type="button"
                                    >
                                        <span class="sr-only">Open options</span>
                                        <!-- Heroicon name: solid/dots-vertical -->
                                        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                        </svg>
                                    </button>
                                    <!--
                                  Dropdown panel, show/hide based on dropdown state.

                                  Entering: "transition ease-out duration-100"
                                    From: "transform opacity-0 scale-95"
                                    To: "transform opacity-100 scale-100"
                                  Leaving: "transition ease-in duration-75"
                                    From: "transform opacity-100 scale-100"
                                    To: "transform opacity-0 scale-95"
                                -->
                                    <transition
                                        enter-active-class="transition ease-out duration-100"
                                        enter-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95"
                                    >
                                        <div
                                            v-show="showDropdown === post.id"
                                            aria-labelledby="challenge-options-menu-0"
                                            aria-orientation="vertical"
                                            class="absolute z-40 right-7 top-0 mt-1 mx-3 w-48 bg-white rounded-md shadow-lg divide-gray-200 divide-y origin-top-right ring-1 ring-black ring-opacity-5"
                                            role="menu"
                                        >
                                            <div class="py-1" role="none">
                                                <Link :href="route('admin.post', { post: post })" class="group flex items-center px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" role="menuitem"> Review </Link>
                                                <a @click="toggleDropdown(null)" class="group flex items-center px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" :href="post.showUrl" target="_blank" role="menuitem"> Open </a>
                                            </div>
                                            <div class="py-1" role="none">
                                                <a class="group flex items-center px-4 py-2 text-gray-700 hover:text-gray-900 text-sm hover:bg-gray-100" href="#" role="menuitem"> Delete </a>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <pagination :data="paginate" class="mb-16 mt-5 mx-8" />

        <div v-if="showDropdown" @click="showDropdown = null" class="absolute z-10 inset-0"></div>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout"
import AdminHeader from "@/Components/Admin/AdminHeader"
import Pagination from "@/Components/Pagination"
import Tooltip from "@/Components/Tooltip"
import AdminBreadcrumbs from "@/Components/Admin/Breadcrumbs"

export default {
    components: { Tooltip, Pagination, AdminHeader, AdminBreadcrumbs },
    layout: AdminLayout,

    props: {
        paginate: Object,
    },

    computed: {
        posts() {
            return this.paginate.data
        },
        crumbs() {
            return [
                {
                    text: "Challenges",
                    href: this.route("admin.posts"),
                },
            ]
        },
    },

    data() {
        return {
            showDropdown: null,
        }
    },
    methods: {
        toggleDropdown(id) {
            this.showDropdown = this.showDropdown !== id ? id : null
        },
    },
}
</script>
